import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <div>
        {" "}
        <p>
          Made with <span>React</span> at{" "}
          <a href="https://www.lereacteur.io/">Le Reacteur</a> By{" "}
          <a href="https://github.com/polatonur">Onur</a>
        </p>
      </div>
    </footer>
  );
};
export default Footer;
